import React, { useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import CloseIcon from "../../images/close-button-black.png";
import plusButton from "../../images/plus-button.png";
import redMapPointer from "../../images/red-map-pointer.png";
import {
  Row,
  Col,
  Button,
  Modal,
  Input,
  InputGroup,
  Form,
  FormGroup,
} from "reactstrap";
import ModalAddNewAddressIdExpress from "./ModalAddNewAddressIdExpress";
import ModalConfirmation from "./ModalConfirmation";
import {
  setDefaultAddress,
  deleteShippingAddress,
} from "../../actions/postalCodeAction";
import { connect } from "react-redux";

function ModalAddressBookIdExpress({
  dataAddress,
  isOpen,
  onToggle,
  provinces,
  countries,
  id,
  changeId,
  defaultId,
  submitShipping,
  cities,
  changeAddressDefault,
  getHistoryShipping,
  deleteShippingAddress,
  handleSelectedAddress,
}) {
  const [shippingId, setShippingId] = useState(id);
  const [modalForm, setModalForm] = useState(false);
  const [titleHeader, setTitleHeader] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(0);
  const [selectedAddress, setSelectedAddress] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [titleConfirmation, setTitleConfirmation] = useState("");
  const [itemId, setItemId] = useState(null);

  // Modal edit
  function toggleModalForm(title, id) {
    if (title === "EDIT ADDRESS") {
      setIsEdit(true);
      setTitleHeader(title);
      setModalForm(!modalForm);
      setEditId(id);
    } else {
      setIsEdit(false);
      setTitleHeader(title);
      setModalForm(!modalForm);
    }
  }

  function changeDefaultAddress(id) {
    changeAddressDefault(id)
      .then((_) => getHistoryShipping())
      .catch((e) => null);
  }

  function deleteAddress(id) {
    deleteShippingAddress(id)
      .then((_) => getHistoryShipping())
      .catch((_) => null);
  }

  if (modalForm) {
    return (
      <ModalAddNewAddressIdExpress
        dataAddress={dataAddress}
        isOpen={modalForm}
        onToggle={toggleModalForm}
        title={titleHeader}
        countries={countries}
        provinces={provinces}
        cities={cities}
        isEdit={isEdit}
        editId={editId}
        toggleAdd={onToggle}
      />
    );
  } else {
    return (
      <Modal
        isOpen={isOpen}
        toggle={onToggle}
        modalClassName={"container-address-v2"}
      >
        <div className="address-header">
          {/* <p onClick={props.onToggle} style={{color: '#fff', textAlign:'right', cursor: 'pointer'}}>close</p> */}
          <div className="text-title">
            <p>Address Book</p>
          </div>
          <div
            onClick={() => {
              onToggle();
              setSelectedAddress(false);
            }}
            className="icon-close"
          >
            <KickImage className="btn-close-modal" src={CloseIcon} alt="close" />
          </div>
        </div>
        <div className="address-content">
          {dataAddress.length > 0 && (
            <div
              onClick={() => toggleModalForm("ADD NEW ADDRESS")}
              className="add-address"
            >
              <span>Add New Address</span>
            </div>
          )}
          {dataAddress.length > 0 &&
            dataAddress.map((item, index) => {
              let selectedProvince = provinces.find(
                (p) => p.name === item.province
              );

              let selectedCountry = countries
                ? countries.find((c) => c.code3 === item.country)
                : null;

              let selectedItem = {
                ...item,
                id_province: selectedProvince ? selectedProvince.id : null,
                //city: selectedCity.id
              };
              return (
                <Row key={index}>
                  <Col sm={6} md={8} lg={10}>
                    <p>
                      {item.alias} - {item.full_name}
                    </p>
                    <p>{item.phone_number}</p>
                    <p>{item.street_address}</p>
                    <p>{item.note}</p>
                    <p>
                      {item.city}, {item.province}, {item.postal_code}
                    </p>
                    <p>{selectedCountry ? selectedCountry.name : null}</p>
                    <div className="address-btn">
                      <div
                        onClick={() => {
                          setOpenModalConfirmation(!openModalConfirmation);
                          setTitleConfirmation("Deffault Address");
                          setItemId(item.id);
                          // changeDefaultAddress(item.id)
                        }}
                        style={{
                          backgroundColor:
                            item.is_default === true ? "#242424" : "#f1f1f1",
                          color:
                            item.is_default === true ? "#f1f1f1" : "#242424",
                        }}
                        className="address-default"
                      >
                        {item.is_default === true
                          ? "Default Address"
                          : "Set as default"}
                      </div>
                      <div
                        onClick={() => toggleModalForm("EDIT ADDRESS", item.id)}
                        className="address-edit"
                      >
                        Edit
                      </div>
                      <div
                        onClick={() => {
                          setOpenModalConfirmation(!openModalConfirmation);
                          setTitleConfirmation("Delete Address");
                          setItemId(item.id);
                          // deleteAddress(item.id)
                        }}
                        className="address-delete"
                      >
                        Hapus
                      </div>
                    </div>
                  </Col>
                  <Col sm={6} md={4} lg={2}>
                    <input
                      style={{ cursor: "pointer" }}
                      checked={selectedAddress && id === item.id ? true : false}
                      type="radio"
                      onClick={() => {
                        changeId(item.id);
                        setSelectedAddress(true);
                      }}
                    />
                  </Col>
                </Row>
              );
            })}
          {dataAddress.length <= 0 && (
            <div clasName="address-no-data">
              <KickImage
                style={{
                  width: "180px",
                  height: "auto",
                  margin: "0px 0px 15px 0px",
                  display: "block",
                  margin: "20px auto 20px auto",
                }}
                src={redMapPointer}
                alt="address point"
              />
              <h4
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontFamily: "Nunito Bold",
                }}
              >
                You haven't add any address yet
              </h4>
              <h4
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  marginBottom: "15px",
                }}
              >
                Add your first shipping address by click the button below
              </h4>
              <div
                onClick={() => toggleModalForm("ADD NEW ADDRESS")}
                className="add-address"
              >
                <span>Add New Address</span>
              </div>
            </div>
          )}
        </div>
        {dataAddress.length > 0 && (
          <div className="address-footer">
            <Row className="row-bottom">
              {selectedAddress ? (
                <Col
                  onClick={() => {
                    submitShipping();
                    setSelectedAddress(false);
                  }}
                  className="col-address-book"
                >
                  Use This Address
                </Col>
              ) : (
                <Col
                  className="col-address-book"
                  style={{
                    backgroundColor: "#a7a7a7",
                    border: "2px solid #a7a7a7",
                    cursor: "normal",
                  }}
                >
                  Use This Address
                </Col>
              )}
            </Row>
          </div>
        )}
        <ModalConfirmation
          isOpen={openModalConfirmation}
          isToggle={() => setOpenModalConfirmation(!openModalConfirmation)}
          title={titleConfirmation}
          handleOption={() => {
            if (titleConfirmation === "Delete Address") {
              deleteAddress(itemId);
            } else if (titleConfirmation === "Deffault Address") {
                changeDefaultAddress(itemId);
            }
          }}
        />
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeAddressDefault: (payload) => dispatch(setDefaultAddress(payload)),
  deleteShippingAddress: (payload) => dispatch(deleteShippingAddress(payload)),
});

export default connect(null, mapDispatchToProps)(ModalAddressBookIdExpress);
